// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"bea7ba13","506":"ab833e72","574":"fd074244","660":"9b65ce2a","670":"c82702f0","712":"656d63a9","807":"c0274956","885":"cc00e53f","897":"07361e31"}[chunkId] + ".css";
};